// // src/components/common/Toast.jsx
// import React, { useEffect } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import { hideToast } from '../../redux/slices/uiSlice.js'

// export default function Toast() {
//     const dispatch = useDispatch()
//     const toast = useSelector(state => state.ui.toast)

//     useEffect(() => {
//         if (toast && toast.duration > 0) {
//             const timer = setTimeout(() => {
//                 dispatch(hideToast())
//             }, toast.duration)

//             return () => clearTimeout(timer)
//         }
//     }, [toast, dispatch])

//     if (!toast) return null

//     const getToastStyles = (type) => {
//         const baseStyles = 'fixed top-4 right-4 z-50 max-w-sm w-full p-4 rounded-lg shadow-lg transform transition-transform duration-300'

//         switch (type) {
//             case 'success':
//                 return `${baseStyles} bg-green-50 border border-green-200 text-green-800`
//             case 'error':
//                 return `${baseStyles} bg-red-50 border border-red-200 text-red-800`
//             case 'warning':
//                 return `${baseStyles} bg-yellow-50 border border-yellow-200 text-yellow-800`
//             case 'info':
//                 return `${baseStyles} bg-blue-50 border border-blue-200 text-blue-800`
//             default:
//                 return `${baseStyles} bg-gray-50 border border-gray-200 text-gray-800`
//         }
//     }

//     const getIcon = (type) => {
//         switch (type) {
//             case 'success':
//                 return (
//                     <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                         <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//                     </svg>
//                 )
//             case 'error':
//                 return (
//                     <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                         <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
//                     </svg>
//                 )
//             case 'warning':
//                 return (
//                     <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                         <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
//                     </svg>
//                 )
//             default:
//                 return (
//                     <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                         <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
//                     </svg>
//                 )
//         }
//     }

//     return (
//         <div className={getToastStyles(toast.type)}>
//             <div className="flex items-start">
//                 <div className="flex-shrink-0">
//                     {getIcon(toast.type)}
//                 </div>
//                 <div className="ml-3 flex-1">
//                     <p className="text-sm font-medium">{toast.message}</p>
//                 </div>
//                 <div className="ml-4 flex-shrink-0">
//                     <button
//                         onClick={() => dispatch(hideToast())}
//                         className="inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
//                     >
//                         <span className="sr-only">Close</span>
//                         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                             <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
//                         </svg>
//                     </button>
//                 </div>
//             </div>
//         </div>
//     )
// }



// src/components/common/Toast.jsx
import React, { useEffect } from 'react'

export default function Toast({ show, message, type = 'success', onClose, duration = 3000 }) {
    useEffect(() => {
        if (show && duration > 0) {
            const timer = setTimeout(onClose, duration)
            return () => clearTimeout(timer)
        }
    }, [show, duration, onClose])

    if (!show) return null

    const styles = {
        success: 'bg-green-50 border-green-200 text-green-800',
        error: 'bg-red-50 border-red-200 text-red-800',
        warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
        info: 'bg-blue-50 border-blue-200 text-blue-800'
    }

    const icons = {
        success: (
            <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
        ),
        error: (
            <svg className="w-5 h-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
        )
    }

    return (
        <div className="fixed top-4 right-4 z-50">
            <div className={`flex items-center p-4 rounded-lg border ${styles[type]} shadow-lg max-w-sm`}>
                <div className="flex-shrink-0">
                    {icons[type]}
                </div>
                <div className="ml-3">
                    <p className="text-sm font-medium">{message}</p>
                </div>
                <button
                    onClick={onClose}
                    className="ml-auto flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors duration-200"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>
    )
}